import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from '../../context/GlobalContext';
import AccessibleContent from '../../utils/AccessibleContent';

const DetailPage = () => {
  const { t } = useTranslation();
  const { store, currentLanguage } = useGlobalContext();
  
  const lang = currentLanguage?.code || 'en';
  const img = store.help?.image;

  const isMeaningfulHtml = (html) => {
    if (!html) return false;
    let text = html.replace(/<[^>]*>/g, '');
    text = text.replace(/&nbsp;/gi, ' ');
    text = text.replace(/\s+/g, ' ').trim();
    return text.length > 0;
  };

  if (!store || !store.texteAccroche) {
    return (
      <div className="content">
        <div className="mainContent">
          <div className="wrapper mainWhiteBox">
            <p></p>
          </div>
        </div>
      </div>
    );
  }

  const rawAccroche = store.texteAccroche?.[lang] || '';
  const accrocheHtml = rawAccroche
    ? rawAccroche.replace('<p>', '<h2>').replace('</p>', '</h2>')
    : '';

  const showAccroche = isMeaningfulHtml(accrocheHtml);

  return (
    <div className="content">
      <div id="topSection">
        <div className={`overlayBox ${store.mainImageFilter ? 'overlay' : ''}`}>
          <div className="wrapper">
          {showAccroche && (
            <AccessibleContent
              htmlContent={store.texteAccroche?.[lang]
                ? store.texteAccroche[lang].replace("<p>", "<h2>").replace("</p>", "</h2>")
                : `<h2>${t("Recevez votre carte cadeau")}</h2>`}
              className="headContent accrocheColor"
            />
            )}
          </div>
        </div>
      </div>
      <div className="mainContent">
        <div className="wrapper mainWhiteBox">
          <div className="modalAction">
            <a href="/home" className="buyCard returnToHome">
              {t("Acheter une e carte cadeau")}
            </a>
          </div>
          {img && (
            <div className="mainImg">
              <img src={img} alt="Help" />
            </div>
          )}
          <div
  className="contentBody mainColor"
  style={{
    marginLeft: window.innerWidth < 768 ? 16 : img ? 16 : 16
  }}
>
            <h1>{store.title1?.[lang] || ''}</h1>
            <AccessibleContent
              htmlContent={store.editorText?.[lang] || ''}
              className="modalcontent"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailPage;
